import Text from "./Text";
import { useState, useEffect } from "react";
import Dropdown from "./Dropdown";
import TextContainer from "./TextContainer";
import { Col, Row, useIsMobile } from "./Flexbox";
import { MenuItem } from "@mui/material";
import Button from "@mui/material/Button";

const CreateUser = ({onClose, theme, roles, initialData = {mail: "", name: "", request_id: ""}, createUser, updateRequest, onSuccess, isDark}) => {
    const isMobile = useIsMobile();
    const [mail, setMail] = useState("");
    const [name, setName] = useState("");
    const [isCreating, setIsCreating] = useState(false);
    const [permissions, setPermissions] = useState("");
    const [formMessage, setFormMessage] = useState({text: null, color: null});
    const [error, setError] = useState(null);

    const departments = Object.keys(roles);

    const formatMessage = (text, color) => {
        setFormMessage({text: text, color: color || theme.Red})
    }

    useEffect(() => {
        setMail(initialData?.mail || "");
        setName(initialData?.name || "");
    }, [initialData])

    const handleCreateUser = async (e) => {
        e.preventDefault();

        formatMessage(null);
        if (!mail || !name || !permissions) {
            formatMessage("Todos los campos son obligatorios");
            return;
        }
        setIsCreating(true);

        const userData = {mail, name, permissions: roles[permissions]}
        const updatePayload = {mail: initialData.mail, request_id: initialData.request_id, action: 'ACCEPT'}
        const update = await updateRequest(updatePayload);

        if (!update.success) {
            setError(update.message)
        }

        const result = await createUser(userData);

        if (result.success) {
            formatMessage("Usuario creado con éxito", theme.Verde);
            setTimeout(() => {
                onSuccess();
            }, 3000);
        } else {
            setError(result.message);
        }
        
        setIsCreating(false);
    }

    return (
        <form onSubmit={handleCreateUser}>
            <div style={{position: 'fixed', top:0, left:0, right:0, bottom:0, background: 'rgba(0, 0, 0, 0.5)', alignItems: 'center', display: 'flex', justifyContent: 'center', zIndex: 1000, boxSizing: 'border-box'}}>
                <Col style={{width:'100%', height: '100%', maxWidth: '600px', maxHeight: '450px', flex:'none', alignItems:'flex-start', paddingLeft: isMobile ? 16 : 32, paddingRight: isMobile ? 16 : 32, paddingTop: 32, paddingBottom: 32, marginTop: 32, backgroundColor: theme.White,  borderRadius: 4, boxShadow: isDark ? '0px 10px 40px rgba(0, 0, 0, 0.8)' : '0px 10px 30px rgba(0, 0, 0, 0.1)', overflowY: 'auto'}}>
                    <Col style={{height: 65, flex:'none', width: '100%', alignItems:'flex-start', justifyContent: 'space-between'}}>
                        <Text color={theme.Black} size={21} weight={"bold"}>Crear usuario</Text>
                    </Col>
                    <Col style={{alignItems: 'flex-start', justifyContent: 'space-between', width: '100%', gap: 32}}>
                        <Col style={{alignItems: 'start', width: '100%'}}>
                            <Text color={theme.Black} size={15} weight={"medium"}>Correo</Text>
                            <TextContainer style={{width: '100%', height: 36}} value={mail} theme={theme} placeHolder="something@example.com.mx" onChange={(value) => setMail(value)}/>
                        </Col>
                        <Col style={{alignItems: 'start', width: '100%'}}>
                            <Text color={theme.Black} size={15} weight={"medium"}>Nombre</Text>
                            <TextContainer style={{width: '100%', height: 36}} value={name} theme={theme} placeHolder="" onChange={(value) => setName(value)}/>
                        </Col>
                        <Col style={{alignItems: 'start', width: '100%'}}>
                            <Text style={{marginBottom: 5}} color={theme.Black} size={15}  weight={"medium"}>Rol de permisos</Text>
                            <Dropdown theme={theme}  value={permissions} onChange={(value) => setPermissions(value)} style={{width: '100%', height: 36}}>
                                {departments.map((role) => (
                                    <MenuItem key={role} value={role}>{role}</MenuItem>
                                ))}
                            </Dropdown>
                        </Col>
                    </Col>
                    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start', width: '100%', gap: 4, position: 'relative', marginTop: '10px'}}>
                        {formMessage && <Text color={formMessage.color} size={12} style={{position: 'absolute' }}>{formMessage.text}</Text>}
                        {error  && <Text color="red" size={12} style={{position: 'absolute' }}>{error}</Text>}
                    </div>
                    <Row style={{width: '100%', justifyContent: 'end', paddingTop: 64, gap: 16}}>
                        <Text style={{ cursor:'pointer', transition:'transform 2s ease'}} color={theme.Lao} size={15} onClick={onClose}>Cancelar</Text>
                        <Button disableElevation type="submit" disabled={isCreating} variant="contained" sx={{height: 20, backgroundColor: 'transparent', color: isCreating ? theme.Ey : theme.Magenta, fontSize: 15, textTransform: 'none'}}>Crear usuario</Button>            
                    </Row>
                </Col>
            </div>
        </form>
    )
}

export default CreateUser;